import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MomentDateAdapter} from "@angular/material-moment-adapter";
import {MY_FORMATS} from "../../../shared/util.service";
import {ImpulseService} from "../impulse.service";

@Component({
    selector: 'app-counter-reset-dialog',
    templateUrl: './counter-reset-dialog.component.html',
    styleUrls: ['./counter-reset-dialog.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class CounterResetDialogComponent implements OnInit {

  item: any = {
    date: null,
    value: null
  };
  minutes = [];
  hours = [];
  constructor(
      private service: ImpulseService,
      public dialogRef: MatDialogRef<CounterResetDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.initDates();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  initDates() {
    for (let i = 0; i < 60; i++) {
      if (i < 10) {
        this.minutes.push(`0${i}`);
      } else {
        this.minutes.push(`${i}`);
      }
    }
    for (let i = 0; i < 24; i++) {
      if (i < 10) {
        this.hours.push(`0${i}`);
      } else {
        this.hours.push(`${i}`);
      }
    }
  }

  onSaveClick() {
    if (this.item.value === null) {
      return this.service.notiService.open('Set the recording value!');
    }

    if (!this.item.date || !this.item.hour || !this.item.minute) {
      return this.service.notiService.open('Set the recording date, hour and minute!');
    }
    this.item.time = `${this.item.date.format('YYYY-MM-DD')} ${this.item.hour}:${this.item.minute}:00`;
    this.item.measure = this.data.measureID;

    this.service.saveResetCounter(this.data.deviceID, this.item).subscribe((resp:any) => {
      if (resp && resp.node_id) {
        this.service.notiService.open("Mentve.");
        this.dialogRef.close(resp);
      } else {
        this.service.notiService.open(resp.error ? resp.error : "Hiba a mentés közben.");
        console.log(resp);
      }
    })
  }

}
